<router-outlet></router-outlet>

<div kendoDialogContainer></div>


<audio id="beep-bot" >   <source src="/assets/audio/beep-bot.mp3" /> </audio>
